var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-table',{ref:"table",attrs:{"columns":_vm.columns,"queryParams":_vm.queryParams,"url":_vm.url,"defaultLoadData":false}})}
var staticRenderFns = []

export { render, staticRenderFns }